import { render } from "./SqlEditor.vue?vue&type=template&id=567fb9c3"
import script from "./SqlEditor.vue?vue&type=script&lang=js"
export * from "./SqlEditor.vue?vue&type=script&lang=js"

import "./SqlEditor.vue?vue&type=style&index=0&id=567fb9c3&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__